import cx from 'classnames';

const LinesExpandTreeIcon = (isFirst: boolean): JSX.Element => {
  const d = isFirst ? 'M1 0.999999L1 30 5 30L16 30' : 'M1 0.999999L1 59 5 59L16 59';

  return (
    <svg
      width="17"
      height={isFirst ? 31 : 60}
      viewBox={isFirst ? '0 0 17 31' : '0 0 17 59'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cx('absolute left-[57px] translate-x-[-0.5px]', isFirst ? 'top-0' : '-top-[30px]')}
    >
      <path d={d} stroke="#050526" strokeOpacity="0.12" strokeLinecap="round" />
    </svg>
  );
};

export default LinesExpandTreeIcon;
